module.exports = __webpack_public_path__ + "img/코엑스 맛집.28d856f4.png";